module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('strong', [_vm._v("Placa")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.plate),
      expression: "filter.plate"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "plate"
    },
    domProps: {
      "value": (_vm.filter.plate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "plate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-inline col-md-3"
  }, [_c('strong', [_vm._v("Data Passagem")]), _vm._v(" "), _c('datepicker', {
    staticClass: "form-control",
    attrs: {
      "format": "dd/MM/yyyy",
      "language": "pt-br",
      "data-vv-as": "data passagem"
    },
    model: {
      value: (_vm.occurrenceDate),
      callback: function($$v) {
        _vm.occurrenceDate = $$v
      },
      expression: "occurrenceDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        return _vm.searchRefunds()
      }
    }
  }, [_vm._v("Buscar")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.refunds.length > 0) ? _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }],
    staticClass: "col-xs-12 min-content"
  }, [_c('table', [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.refunds), function(r, i) {
    return _c('tr', {
      key: i
    }, [_c('td', [_vm._v(_vm._s(r.refundPassageId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(r.plate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTime")(r.occurrenceDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(r.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(r.refundTypeDescription))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "center"
      }
    }, [_vm._v(_vm._s(r.classifiedClass))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("cents")(r.passageValue)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(r.tagSerialNumber))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "center"
      }
    }, [_c('i', {
      staticClass: "icon-info",
      attrs: {
        "title": 'Detalhes da contestação ' + r.refundPassageId
      },
      on: {
        "click": function($event) {
          return _vm.getRefundDetails(r)
        }
      }
    })]), _vm._v(" "), (r.status == 1) ? _c('td', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("Pendente")]) : (r.status == 2) ? _c('td', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("Pendente")]) : (r.status == 3) ? _c('td', {
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v("Aprovado")]) : (r.status == 4) ? _c('td', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("Pendente")]) : (r.status == 5) ? _c('td', {
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v("Aprovado")]) : (r.status == 6) ? _c('td', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("Recusado")]) : (r.status == 7) ? _c('td', {
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v("Aprovado")]) : _vm._e()])
  }), 0)])]) : _vm._e()]), _vm._v(" "), (_vm.refundSelected) ? _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "refundDetails",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "refundDetails",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "modal-body scroll"
  }, [_c('div', {
    attrs: {
      "id": "detailsCurrentPassage"
    }
  }, [_c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._m(3), _vm._v(" "), _c('p', {
    attrs: {
      "id": "detailstransactionId"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.refundSelected.transactionId) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(4), _vm._v(" "), _c('p', {
    attrs: {
      "id": "detailsoccurrenceDate"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("dateTime")(_vm.refundSelected.occurrenceDate)) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(5), _vm._v(" "), _c('p', {
    attrs: {
      "id": "detailsinsertDate"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("dateTime")(_vm.refundSelected.insertDate)) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(6), _vm._v(" "), (_vm.refundSelected.debitado == -1) ? _c('p', [_vm._v("Erro")]) : _vm._e(), _vm._v(" "), (_vm.refundSelected.debitado == 0) ? _c('p', [_vm._v("Não")]) : _vm._e(), _vm._v(" "), (_vm.refundSelected.debitado == 1) ? _c('p', [_vm._v("Sim")]) : _vm._e(), _vm._v(" "), (_vm.refundSelected.debitado == 2) ? _c('p', [_vm._v("Isento")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(7), _vm._v(" "), _c('p', {
    attrs: {
      "id": "detailsNameUser"
    }
  }, [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(8), _vm._v(" "), _c('p', {
    attrs: {
      "id": "detailsCpfCnpj"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("cpfCnpj")(_vm.refundSelected.taxPayerIdNumber)) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(9), _vm._v(" "), _c('p', {
    attrs: {
      "id": "detailsAssociate"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.refundSelected.associate) + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(10), _vm._v(" "), _c('p', {
    attrs: {
      "id": "detailsPraca"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.refundSelected.description) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(11), _vm._v(" "), _c('p', {
    attrs: {
      "id": "detailsPista"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.refundSelected.pista) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(12), _vm._v(" "), _c('p', {
    attrs: {
      "id": "detailsCategoriaCorreta"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.refundSelected.categoryCorrect) + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(13), _vm._v(" "), _c('p', {
    attrs: {
      "id": "detailsCategoriaCobrada"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.refundSelected.classifiedClass) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._m(14), _vm._v(" "), _c('p', {
    attrs: {
      "id": "detailsPassageValue"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("cents")(_vm.refundSelected.passageValue)) + "\n                  ")])]), _vm._v(" "), (_vm.dataEstorno) ? _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(15), _vm._v(" "), _c('p', {
    attrs: {
      "id": "detailsDataDebitoRecusadoEst"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("dateTime")(_vm.dataEstorno)) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.dataCancelaEstorno) ? _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(16), _vm._v(" "), _c('p', {
    attrs: {
      "id": "detailsDataDebitoRecusadoCanc"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("dateTime")(_vm.dataCancelaEstorno)) + "\n                    ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(17), _vm._v(" "), _c('p', {
    attrs: {
      "id": "detailsCategoriaCobrada"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("cents")(_vm.refundSelected.valueCategCorrect)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(18), _vm._v(" "), _c('p', {
    attrs: {
      "id": "detailsReturnValue"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("cents")(_vm.refundSelected.returnValue)) + "\n                  ")])])]), _vm._v(" "), (_vm.hasComments) ? _c('div', [_c('br'), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._l((_vm.refundPassageHist), function(c) {
    return _c('div', {
      key: c.refundPassageHistId
    }, [(c.userType == 2 && c.status == 6) ? _c('div', {
      staticClass: "alert alert-warning"
    }, [_c('p', [_c('strong', [_vm._v(_vm._s(c.userTypeString) + ":")]), _vm._v("\n                    " + _vm._s(c.comments) + "\n                    "), _c('strong', [_vm._v(" " + _vm._s(_vm._f("dateTime")(c.createdDate)) + " ")])])]) : _vm._e()])
  })], 2) : _vm._e()])]), _vm._v(" "), _vm._m(20)])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "title title-plans"
  }, [_vm._v("Contestação")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "8%"
    }
  }, [_vm._v("Cód. Contestação")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "8%"
    }
  }, [_vm._v("Placa")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "12%"
    }
  }, [_vm._v("Data da Passagem")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("Praça")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("Categoria Passagem")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("Valor Cobrado")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("Tag(serial)")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "3%"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("Status")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "refundDetails"
    }
  }, [_vm._v("\n              Dados da Passagem\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "detailstransactionId"
    }
  }, [_c('strong', [_vm._v("Transação")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "detailsoccurrenceDate"
    }
  }, [_c('strong', [_vm._v("Ocorrência")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "detailsinsertDate"
    }
  }, [_c('strong', [_vm._v("Contestação")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "detailsDebitado"
    }
  }, [_c('strong', [_vm._v("Debitada")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "detailsNameUser"
    }
  }, [_c('strong', [_vm._v("Nome / Razão Social")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "detailsCpfCnpj"
    }
  }, [_c('strong', [_vm._v("CPF / CNPJ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "detailsAssociate"
    }
  }, [_c('strong', [_vm._v("Concessionária")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "detailsPraca"
    }
  }, [_c('strong', [_vm._v("Praça")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "detailsPista"
    }
  }, [_c('strong', [_vm._v("Pista")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "detailsCategoriaCorreta"
    }
  }, [_c('strong', [_vm._v("Categoria Correta")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "detailsCategoriaCobrada"
    }
  }, [_c('strong', [_vm._v("Categoria Cobrada")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "detailsPassageValue"
    }
  }, [_c('strong', [_vm._v("Valor")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "detailsDataDebitoRecusadoEst"
    }
  }, [_c('strong', [_vm._v("Data do estorno passagem")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "detailsDataDebitoRecusadoCanc"
    }
  }, [_c('strong', [_vm._v("Data canc. est. passagem")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "detailsCategoriaCobrada"
    }
  }, [_c('strong', [_vm._v("Valor Correto")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "detailsReturnValue"
    }
  }, [_c('strong', [_vm._v("Valor a Ressarcir")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "Motivo"
    }
  }, [_c('strong', [_vm._v("Comentários: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              Voltar\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-2728e283!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/refund.vue
// module id = 2071
// module chunks = 1